<script lang="ts" setup>
	import BaseModal from '@/components/modals/BaseModal.vue';
	import {computed, ref} from 'vue';
	import {useI18n} from 'vue-i18n';

	const {t} = useI18n();

  type AvailabilityWindow = Window & {
    syngentaTenant?: boolean;
  };

  const availabilityWindow = window as AvailabilityWindow;
  const isSyngentaTenant = computed(() => availabilityWindow.syngentaTenant === true);

	defineProps<{
		name: string
	}>();

	const emits = defineEmits(['close']);

	const loading = ref(false);

	const backToCart = () => {
		emits('close');
	};

	const confirmButtonClasses = computed(() => {
		const classes = ['button--green'];

		if (loading.value) {
			classes.push('loading');
		}

		return classes.join(' ');
	});

	const goToOrders = () => {
		loading.value = true;
		window.location.href = window.myDummenBaseUrl;
	};
</script>

<template>
	<base-modal :confirm-button-class="confirmButtonClasses"
	            cancel-button-text="Back to cart"
	            confirm-button-text="Go to orders"
	            @cancel="backToCart"
	            @confirm="goToOrders">
		<template v-slot:title>
			{{ t('shoppingcart.modal.createpo.success.title') }}
		</template>

		<p>
			<strong>Order {{ name }}</strong>
      {{ isSyngentaTenant ? t('site.syngenta.shoppingcart.modal.createpo.success.suffix.text') : t('shoppingcart.modal.createpo.success.suffix.text') }}
		</p>
	</base-modal>
</template>
